/* eslint-disable @typescript-eslint/no-explicit-any */
// src/features/parentDataSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IParentMessageData {
  type: string;
  message: string;
  source: string;
  timestamp: string;
  userEmail: string;
  userId: string;
  orgId: string;
  region: string;
  courseId: string;
  pageId: string;
  sharedAccountId: string;
  ltiPlatformId: string;
  loreeUserEmail: string;
  env: string;
  trackingId: string | null;
  isCollab?: boolean;
  collabType?: string;
  isParentEdit?: boolean;
}

export interface IToken {
  accessToken: string | null;
  refreshToken: string | null;
}
export interface ParentDataInterface {
  parentData: {
    data: IParentMessageData;
    token: IToken;
    customConfiguration: any;
    interactiveState: string;
  };
}

export interface ParentDataState {
  data: IParentMessageData | null;
  token: IToken | null;
  customConfiguration: any;
  interactiveState: string;
}

const initialState: ParentDataState = {
  data: null,
  token: null,
  customConfiguration: null,
  interactiveState: '',
};

const parentDataSlice = createSlice({
  name: 'parentData',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<IParentMessageData>) => {
      state.data = action.payload;
    },
    setToken: (state, action: PayloadAction<IToken>) => {
      state.token = action.payload;
    },
    setCustomConfiguration: (state, action: PayloadAction<any>) => {
      state.customConfiguration = action.payload;
    },
    setInteractiveState: (state, action: PayloadAction<any>) => {
      state.interactiveState = action.payload;
    },
  },
});

export const { setData, setToken, setCustomConfiguration, setInteractiveState } =
  parentDataSlice.actions;
export default parentDataSlice.reducer;
